module.exports = __webpack_public_path__ + "assets/img/ac704ec2b3bf1e9bb5bb2809212fe640.svg";